import { LevelPieceType } from "../level_config.js";
import { LevelPackService } from "./level_pack_service.js";

export class BlockUnlocks
{
  private static readonly CUBE_MATERIALS = [ "plywood", "brick", "plywood2" ];
  private static readonly MATERIALS: Record<LevelPieceType, string[]> = {
    [LevelPieceType.Cube]: [],
    [LevelPieceType.Stone]: [ "stone" ],
    [LevelPieceType.Jar]: [ "glass", "jar" ],
    [LevelPieceType.Cone]: [ "cone" ],
    [LevelPieceType.Metal]: [ "iron", "metal" ],
    [LevelPieceType.Ice]: [ "ice" ],
    [LevelPieceType.Tree]: [ "tree", "wood" ],
    [LevelPieceType.Watermelon]: [ "watermelon" ],
    [LevelPieceType.Plastic]: [ "plastic" ],
    [LevelPieceType.RoundMetal]: [ "barrel", "roundmetal" ],
    [LevelPieceType.IronCan]: [ "ironcan" ],
  };

  private readonly unlock_levels = LevelPackService.getUnlockLevels();
  private readonly player_level: number;

  constructor( player_level: number )
  {
    this.player_level = player_level;
  }

  public isUnlocked( type: LevelPieceType, variant?: number, size = 1 ): boolean
  {
    if ( type !== LevelPieceType.Cube )
      return this.isAnyUnlocked( BlockUnlocks.MATERIALS[type] ?? [], size );

    if ( variant === undefined )
      return this.cubeVariants( size ).length > 0;

    const material = BlockUnlocks.CUBE_MATERIALS[variant];
    return material === undefined || this.isAnyUnlocked( [ material ], size );
  }

  public cubeVariants( size = 1 ): number[]
  {
    return BlockUnlocks.CUBE_MATERIALS.flatMap( ( material, variant ) => this.isAnyUnlocked( [ material ], size ) ? [ variant ] : [] );
  }

  private isAnyUnlocked( materials: string[], size: number ): boolean
  {
    if ( this.unlock_levels.size === 0 )
      return true;

    return materials.some( material =>
    {
      const base = this.unlock_levels.get( material );
      const tier = size > 1 ? this.unlock_levels.get( `${material} 1×${size}` ) : undefined;

      return base !== undefined && Math.max( base, tier ?? base ) <= this.player_level;
    } );
  }
}
